import { User } from './../../../models/Users';
import { Entity } from 'src/app/models/entities.model';
// tslint:disable: class-name


export const CONTEXT_ACTION_TYPES = {

    CONTEXT_INIT: '[Context init] -initialize current user context-',
    CONTEXT_INIT_SUCCESS: '[Context init] -initialize current user context success-',
    CONTEXT_INIT_FAIL: '[Context init] -initialize current user context fail-',
    USER_CHANGED_CONTEXT: '[Context Header] -User changed Context-',
    CONTEXT_IMAGE_CHANGED: '[Context Image] -Image changed-',
    DATA_UPDATED: '[Context Image] -Context Data reloaded from server-',
    RESSET: '[Context Signout] -User signed Out-'

};

export class Action_Context_Init {
    readonly type = CONTEXT_ACTION_TYPES.CONTEXT_INIT;
    constructor(public payload: User) { }
}

export class Action_Context_Init_Success {
    readonly type = CONTEXT_ACTION_TYPES.CONTEXT_INIT_SUCCESS;
    constructor(public payload: Entity) { }
}

export class Action_Context_Init_Fail {
    readonly type = CONTEXT_ACTION_TYPES.CONTEXT_INIT_SUCCESS;
    constructor(public payload: Error) { }
}

export class Action_Context_Change {
    readonly type = CONTEXT_ACTION_TYPES.USER_CHANGED_CONTEXT;
    constructor(public payload: Entity) { }
}

export class Action_Context_Image_Changed {
    readonly type = CONTEXT_ACTION_TYPES.CONTEXT_IMAGE_CHANGED;
    constructor(public payload: {id: number, photo_url: string}) { }
}

export class Action_Context_DataUpdated {
    readonly type = CONTEXT_ACTION_TYPES.DATA_UPDATED;
    constructor(public payload: Entity) { }
}

export class Action_Context_Resset {
    readonly type = CONTEXT_ACTION_TYPES.RESSET;
}

